<div class="app-bg">
  <div class="flex flex-col justify-center items-center gap-y-2">
    <div class="flex flex-col h-[250px] overflow-y-auto gap-y-2">
      <div>Gopher Buddy is a tool to help your school keep up-to-date with all of their Chromebooks.</div>

      <div class="flex flex-col">
        <div>It <strong>does</strong> let your school:</div>
        <div>• know who is using the Chromebook</div>
        <div>• know when the Chromebook is used</div>
        <div>• notify you if the Chromebook needs updating</div>
      </div>

      <div class="flex flex-col">
        <div>It does <strong>NOT</strong> record:</div>
        <div>• what you type</div>
        <div>• websites you visit</div>
        <div>• images, video or audio</div>
        <div>• the files on your chromebook</div>
      </div>

      <div class="flex flex-col">
        <div class="text-base font-bold">What do all the buttons do?</div>

        <div class="flex flex-col mt-2">
          <div class="flex flex-row items-center gap-x-2">
            <img class="h-[30px]" src="assets/images/help/show-help.png" alt="show help icon" />
            <div class="font-bold">Show help</div>
          </div>
          <div>Opens and closes this help page.</div>
        </div>

        <div class="flex flex-col mt-2">
          <div class="flex flex-row items-center gap-x-2">
            <img class="h-[30px]" src="assets/images/help/recheck-version.png" alt="recheck version icon" />
            <div class="font-bold">Recheck Chrome verions</div>
          </div>
          <div>Forces Gopher Buddy to recheck your version of Chrome.</div>
        </div>

        <div class="flex flex-col mt-2">
          <div class="flex flex-row items-center gap-x-2">
            <img class="h-[30px]" src="assets/images/help/reload-extension.png" alt="reload extension icon" />
            <div class="font-bold">Reload Gopher Buddy</div>
          </div>
          <div>Reloads the Gopher Buddy Extension. Use this if the extension is acting odd.</div>
        </div>

        <div class="flex flex-col mt-2">
          <div class="flex flex-row items-center gap-x-2">
            <img class="h-[30px]" src="assets/images/help/chrome-update.png" alt="chrome update icon" />
            <div class="font-bold">Chrome update info</div>
          </div>
          <div>Shows info about the current version of Chrome.</div>
        </div>

        <div class="flex flex-col mt-2">
          <div class="flex flex-row items-center gap-x-2">
            <img class="h-[30px]" src="assets/images/help/quick-device-info.png" alt="quick device info icon" />
            <div class="font-bold">Quick device info</div>
          </div>
          <div>Shows a short list of info about this Chromebook</div>
        </div>

        <div class="flex flex-col mt-2">
          <div class="flex flex-row items-center gap-x-2">
            <img class="h-[30px]" src="assets/images/help/clear-cache.png" alt="clear cache button" />
            <div class="font-bold">Clear cache</div>
          </div>
          <div>Clears the Chromebook's cache. Useful if a website is missbehaving.</div>
        </div>

        <div class="flex flex-col mt-2">
          <div class="flex flex-row items-center gap-x-2">
            <img class="h-[30px]" src="assets/images/help/device-info.png" alt="device info button" />
            <div class="font-bold">Device info</div>
          </div>
          <div>
            Takes you to a Gopher Buddy webapp to see addition information about this Chromebook. This button may be
            turned off by your school.
          </div>
        </div>

        <div class="flex flex-col mt-2">
          <div class="flex flex-row items-center gap-x-2">
            <img class="h-[30px]" src="assets/images/help/fix-it.png" alt="Fix-it button" />
            <div class="font-bold">Fix it</div>
          </div>
          <div>Opens the settings page in Chrome. Chrome update settings are on this page.</div>
        </div>
      </div>
    </div>
    <button mat-raised-button color="primary" (click)="openFAQ()">Read the faq</button>
  </div>
</div>
